<template>
  <v-flex xs11 style="position:relative;" class="slide-img">
    <div v-if="item.is_new" class="image-viewer--new" :class="isNewImgClass">
      <img :src="isNewImg">
    </div>

    <div v-if="item.rating_eu" class="image-viewer--rating">
      <RatingIcon :value="item.rating_eu" :mlb2="true"></RatingIcon>
    </div>
    <v-img
      v-if="horizontal"
      :src="item.imageH"
      class="tag-img"
      aspect-ratio="1.8"
      @click="openProgram(item)"></v-img>
    <v-img
      v-else
      :src="item.media && item.media.sm ? item.media.sm : item.image"
      class="tag-img"
      aspect-ratio="0.64"
      @click="openProgram(item)"></v-img>
    <span :class="{ new: item.is_new }"></span>
  </v-flex>
</template>

<script>
import RatingIcon from '@/components/RatingIcon'

let isNewImg = require('@/assets/is-new3.svg')

if (process.env.VUE_APP_HUN !== 'false') {
  console.log('eo')
  isNewImg = require('@/assets/is-new.svg')
}

import vueResponsive from 'vue-responsive'
export default {
  components: { RatingIcon },
  data: () => ({
    middleSize: ['hidden-all', 'lg', 'xl', 'md'],
    smallSize: ['hidden-all','xs', 'sm'],
    isNewImg: isNewImg,
    isNewImgClass: process.env.VUE_APP_HUN === 'true' ? 'hun' : 'cz',
    t: 0
  }),
  props: {
    item: {
      type: Object,
      required: true
    },
    events: {
      type: Boolean,
      required: false,
      default: true
    },
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    openProgram (item) {
      const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isMobile;

      // if (isSafari) {
      //   return this.$router.push({ name: 'IncompatibilityDesktop' })
      // }

      // if(/webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
      //   return this.$router.push({ name: 'AppMobile' })
      // }

      // this.$router.push({ name: 'Video', params: { slug: item.slug } })

      this.$router.push({ name: 'Program', params: { slug: item.slug } })
    }
  },
  directives: {
    responsive: vueResponsive
  }
}
</script>

<style scoped>
  $space: .2rem;
  .tag-img {
    cursor: pointer;
    /*margin-left: 10px;*/
    /*box-shadow: 0 0 2px rgba(55,55,55,0.5);*/
  }
  .image-viewer--new,
  .image-viewer--rating {
    position: absolute;
  }
  .image-viewer--new {
    top: 0;
    right: 0;
    z-index: 1;
    position: absolute;
    margin: 10%;
  }
  .image-viewer--new.hun {
    width: 35%;
  }
  .image-viewer--rating {
    bottom: 0;
    right: 10%;
    /*width: 15%;*/
    z-index: 1;
    padding-bottom: 10%;
  }
  .slide-img {
    padding: 10%;
  }
</style>
<style>
.v-responsive__content {
  cursor: pointer;
}
  .tag-img {
    box-shadow: 0 0 2px rgba(55,55,55,0.5);
    border-radius: 0;
    border: 1px solid white;
  }
  .tag-img * {
    transition: transform 220ms ease-in-out;
    will-change: transform;
  }
  .tag-img:hover * {
    transform: scale(1.1);
  }
</style>
